import { render, staticRenderFns } from "./AccommodationsReviewTable.vue?vue&type=template&id=a341a08e&scoped=true&"
import script from "./AccommodationsReviewTable.vue?vue&type=script&lang=js&"
export * from "./AccommodationsReviewTable.vue?vue&type=script&lang=js&"
import style0 from "./AccommodationsReviewTable.vue?vue&type=style&index=0&id=a341a08e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a341a08e",
  null
  
)

export default component.exports